import React, { createContext, useContext, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

const NotificationContext = createContext({});

export const NotificationProvider = ({ children }) => {
    const [notification, setNotification] = useState({
        open: false,
        message: '',
        severity: 'success'
    });

    const handleClose = () => {
        setNotification(prev => ({ ...prev, open: false }));
    };

    const showNotification = (message, severity = 'success') => {
        setNotification({
            open: true,
            message,
            severity
        });
    };

    const showSuccess = (message) => {
        setNotification({
            open: true,
            message,
            severity: 'success'
        });
    };

    const showError = (message) => {
        setNotification({
            open: true,
            message,
            severity: 'error'
        });
    };

    const showWarning = (message) => {
        setNotification({
            open: true,
            message,
            severity: 'warning'
        });
    };

    return (
        <NotificationContext.Provider value={{ showNotification, showSuccess, showError, showWarning }}>
            {children}
            <Snackbar
                open={notification.open}
                autoHideDuration={6000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleClose}
                    severity={notification.severity}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {notification.message}
                </Alert>
            </Snackbar>
        </NotificationContext.Provider>
    );
};

export const useNotification = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotification must be used within a NotificationProvider');
    }
    return context;
}; 